import gql from 'graphql-tag';

export default gql`
    mutation UpdateLoadProgress($input: LoadProgressEdit) {
        updateLoadProgress(input: $input) {
            errors
        }
    }
`;
